import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import LoanHeader from './loan/LoanHeader'
import Page, { PageProps } from './Page'
import { useLoanContext } from '../contexts/LoanContext'

/**
 * Wrapper component for Page that sets the active loan id from the URL. Can be removed once loan data is pulled from route middleware.
 * * */

const LoanPage = ({ children, breadcrumbs, ...rest }: PageProps) => {
	const { setActiveLoanId } = useLoanContext()
	const { loanId: loanIdParam } = useParams()

	useEffect(() => {
		if (loanIdParam) {
			setActiveLoanId(loanIdParam)
		}
	}, [loanIdParam, setActiveLoanId])

	return (
		<Page breadcrumbs={breadcrumbs} {...rest}>
			{!breadcrumbs && <LoanHeader />}
			<div className="px-5">
				<main>{children}</main>
			</div>
		</Page>
	)
}

export default LoanPage
